import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { Token } from '@/domain/types/Token'
import { HorizontalScroll } from '@/ui/atoms/horizontal-scroll/HorizontalScroll'
import { TokenIcon } from '@/ui/atoms/token-icon/TokenIcon'
import { Info } from '@/ui/molecules/info/Info'

export interface TransactionOverviewSavingsOutcomeProps {
  token: Token
  amount: NormalizedNumber
  postFix?: string
  infoText?: string
  dataTestId?: string
}

export function TransactionOverviewSavingsOutcome({
  token,
  amount,
  postFix,
  infoText,
  dataTestId,
}: TransactionOverviewSavingsOutcomeProps) {
  const formattedAmount = token.format(amount, { style: 'auto' })
  return (
    <HorizontalScroll>
      <div className="flex w-fit items-center gap-2">
        <div className="flex w-fit items-center gap-1.5">
          <TokenIcon token={token} className="h-4 w-4" />
          <div className="flex items-baseline gap-1" data-testid={dataTestId}>
            <div className="typography-label-2 text-primary">{formattedAmount}</div>
            {/* @note: next line is need to maintain backward compatibility with e2e test - amount should include token symbol.
            Also spaces around symbol are important for e2e tests.  */}
            <span className="hidden"> {token.symbol} </span>
            {postFix && <div className="typography-body-4 text-secondary">{postFix}</div>}
          </div>
        </div>
        {infoText && <Info>{infoText}</Info>}
      </div>
    </HorizontalScroll>
  )
}
